export const getEvents = async (welletContext, showId, language, date) => {
  //const monthYear = date.toString().slice(0, 7); 
  const query = `?quantity=1&date=${date.getFullYear()}-${date.getMonth() + 1}-01&lang=${language}`;
  try {
    const response = await welletContext.apis.tickets.get(`/shows/${showId}/events/date${query}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching events:", error);
    throw error;
  }
};
export const getDatesWithEvents = async (showId, date, language, take, welletContext) => {
  //const monthYear = date.toString().slice(0, 7);
  try {
    const response = await welletContext.apis.tickets.get(`/shows/${showId}/datesWithEvents`, {
      params: { date: date, language: language, take: take },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching events:', error);
    throw error;
  }
};

export const fetchEventDetails = async (welletContext, eventId, language) => {
  try {
    const response = await welletContext.apis.tickets.get(
      `/shows/event/${eventId}?lang=${language}`,
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching event details:', error);
    throw error;
  }
};
